<app-dialog
  #dialog
  [key]="'charter-document-viewer'"
  [action]="'charter-document-viewer'"
  [headerTheme]="'simple'"
  [title]="current()?.documentName || 'Documento original'"
  [maxWidth]="'1100px'"
  [scrollableContent]="false">
  @if (current(); as req) {
    <div class="viewer">
      <div class="viewer__meta">
        <div class="viewer__where">
          @if (req.actLabel) {
            <strong>{{ req.actLabel }}</strong>
          }
          @if (req.actDate) {
            <span>· ato de {{ req.actDate | vaultDate }}</span>
          }
          @if (req.page) {
            <span class="viewer__page">página {{ req.page }}</span>
          }
        </div>
        <div class="viewer__actions">
          <app-button
            [icon]="'pi pi-folder-open'"
            [label]="'Ver no Data Room'"
            theme="outline-grey"
            [size]="'small'"
            [noMargin]="true"
            (sendButtonClick)="goToDataRoom()" />
          <app-button
            [icon]="'pi pi-download'"
            [label]="'Baixar'"
            theme="outline-grey"
            [size]="'small'"
            [noMargin]="true"
            [disabled]="!link()"
            (sendButtonClick)="download()" />
        </div>
      </div>

      @if (req.quote) {
        <blockquote class="viewer__quote">
          <i class="pi pi-bookmark" aria-hidden="true"></i>
          <span>"{{ req.quote }}"</span>
        </blockquote>
      }

      <div class="viewer__stage">
        @if (loading()) {
          <div class="viewer__state"><app-cog-loading-spinner /></div>
        } @else if (failed() || !link()) {
          <div class="viewer__state">
            <i class="pi pi-eye-slash" aria-hidden="true"></i>
            <p>Não foi possível abrir este documento aqui. Tente "Ver no Data Room".</p>
          </div>
        } @else if (isPdf()) {
          <app-data-room-pdf-viewer
            [url]="link()!.url"
            [initialPage]="req.page"
            [initialQuery]="searchText()" />
        } @else {
          <app-document-original-viewer class="viewer__original" [fileLink]="link()" />
        }
      </div>
    </div>
  }
</app-dialog>
